<template>
    <div class="row align-items-end">
        <div class="col-md-3 mb-1 mb-md-0">
            <label class="form-label">Yakıt İli</label>
            <v-select-list v-model="province" v-on:input="getDistricts" placeholder="Yakıt İli" label="Name" :options="provinces"/>
        </div>
        <div class="col-md-3 mb-1 mb-md-0">
            <label class="form-label">Yakıt İlçeleri</label>
            <v-select-list :disabled="!province" multiple v-model="district" :options="districts" label="Name" placeholder="Yakıt İlçeleri"></v-select-list>
        </div>
        <div class="col-auto mb-1 mb-md-0">
            <button class="btn btn-secondary" v-on:click="setFilter">Filtrele</button>
        </div>
        <div class="col-auto mb-1 mb-md-0">
            <button class="btn btn-dark" v-on:click="clearFilter">Temizle</button>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'

export default {
    data(){
        return{
            provinces:[],
            districts:[],
            filter:{
                ProvinceId:null,
                DistrictIds:[]
            }
        }
    },
    mounted(){
        this.getProvinces()
    },
    methods:{
        clearFilter(){
            this.filter.ProvinceId = null
            this.filter.DistrictIds = []
            this.$emit("filter",this.filter)
        },
        setFilter(){
            this.$emit("filter",this.filter)
        },
        getProvinces(){
            SystemDataApi.Province().then(response=>{
                this.provinces = response.data.Data
            })
        },
        getDistricts(){
            this.districts = []
            if(this.filter.ProvinceId){
                SystemDataApi.District(this.filter.ProvinceId)
                .then(res=>{
                    this.districts = res.data.Data
                })
            }
        }
    },
    computed:{
        province:{
            get:function(){
                return this.provinces.find(s=>s.Id==this.filter.ProvinceId)
            },
            set:function(value){
                this.filter.ProvinceId = value?.Id || null
            }
        },
        district:{
            get:function(){
                return this.districts.filter(v=>this.filter.DistrictIds.includes(v.Id))
            },
            set:function(value){
                this.filter.DistrictIds = value?.map(v=>v.Id) || []
            }
        },
    }
}
</script>